/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { HistoryDtoUser } from './HistoryDtoUser';
import {
    HistoryDtoUserFromJSON,
    HistoryDtoUserFromJSONTyped,
    HistoryDtoUserToJSON,
} from './HistoryDtoUser';

/**
 * 
 * @export
 * @interface UpdateUpgradeStatusDto
 */
export interface UpdateUpgradeStatusDto {
    /**
     * 
     * @type {number}
     * @memberof UpdateUpgradeStatusDto
     */
    exitCode?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUpgradeStatusDto
     */
    remedyMessage?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUpgradeStatusDto
     */
    errorMessage?: string | null;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof UpdateUpgradeStatusDto
     */
    creatorUser?: HistoryDtoUser | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUpgradeStatusDto
     */
    fromVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUpgradeStatusDto
     */
    targetVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUpgradeStatusDto
     */
    $type?: UpdateUpgradeStatusDtoTypeEnum;
}


/**
 * @export
 */
export const UpdateUpgradeStatusDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCsoPortalDtoUpdateUpgradeStatusDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.CsoPortal.Dto.UpdateUpgradeStatusDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type UpdateUpgradeStatusDtoTypeEnum = typeof UpdateUpgradeStatusDtoTypeEnum[keyof typeof UpdateUpgradeStatusDtoTypeEnum];


/**
 * Check if a given object implements the UpdateUpgradeStatusDto interface.
 */
export function instanceOfUpdateUpgradeStatusDto(value?: unknown): value is UpdateUpgradeStatusDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(UpdateUpgradeStatusDtoTypeEnum)[0];
}

export function UpdateUpgradeStatusDtoFromJSON(json: any): UpdateUpgradeStatusDto {
    return UpdateUpgradeStatusDtoFromJSONTyped(json, false);
}

export function UpdateUpgradeStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUpgradeStatusDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exitCode': !exists(json, 'exitCode') ? undefined : json['exitCode'],
        'remedyMessage': !exists(json, 'remedyMessage') ? undefined : json['remedyMessage'],
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
        'creatorUser': !exists(json, 'creatorUser') ? undefined : HistoryDtoUserFromJSON(json['creatorUser']),
        'fromVersion': !exists(json, 'fromVersion') ? undefined : json['fromVersion'],
        'targetVersion': !exists(json, 'targetVersion') ? undefined : json['targetVersion'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function UpdateUpgradeStatusDtoToJSON(value?: UpdateUpgradeStatusDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'exitCode': value.exitCode,
        'remedyMessage': value.remedyMessage,
        'errorMessage': value.errorMessage,
        'creatorUser': HistoryDtoUserToJSON(value.creatorUser),
        'fromVersion': value.fromVersion,
        'targetVersion': value.targetVersion,
        '$type': value.$type,
    });
}

